import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import './index.css';
import App from './App';
import { ThemeProvider } from './theme/ThemeContext';
import { AuthProvider } from './context/AuthContext';

const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
if (GA_TRACKING_ID) {
  ReactGA.initialize(GA_TRACKING_ID);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  // </React.StrictMode>
);
